import { Grid, useMediaQuery } from "@chakra-ui/react";
import { SelfieItemProps } from "../../interfaces/SelfieItemProps";
import {
  SELFIE_PHOTOS_DESKTOP,
  SELFIE_PHOTOS_MOBILE,
} from "../../utils/constants";
import { SelfieItem } from "./SelfieItem";

interface SelfieSelectorGridProps {
  selfies: SelfieItemProps[];
}

export const SelfieSelectorGrid = (props: SelfieSelectorGridProps) => {
  const [isMobile] = useMediaQuery("(max-width: 767px)");
  const numCols = isMobile ? SELFIE_PHOTOS_MOBILE : SELFIE_PHOTOS_DESKTOP;

  return (
    <Grid templateColumns={`repeat(${numCols}, 1fr)`} gap="0.625rem">
      {props?.selfies?.slice(0, numCols).map((selfie) => (
        <SelfieItem {...selfie} key={selfie.id} />
      ))}
    </Grid>
  );
};
